<template>
  <div class="accordian-main-section">
    <!-- Respond to reviews Begins -->
    <div class="columns accordian-container" v-if="accordionType === 'respondToReviews'">
      <div class="column padding-0">
        <div class="columns flex-align-centre is-flex-mobile" data-track="Portal Home Response To Review Widget" :class="[{'cursor': !$parent.mainSection.accordion.respondToReviews.nextAction || isMobile}]" @click="$parent.handleAccordion('respondToReviews')">
          <div class="column is-flex flex-align-centre flex-80">
            <img src="/static/img/home/respond-to-review.svg" alt="icon">&nbsp;&nbsp;
            <span class="blue-text">Respond To Reviews</span>
          </div>
          <div class="column has-text-right is-narrow is-flex flex-justify-end" v-if="!$parent.mainSection.accordion.respondToReviews.nextAction || isMobile">
            <img :src="`/static/img/ic-${!$parent.mainSection.accordion.respondToReviews.show ? 'right' : 'down'}-arrow.svg`" alt="accordion">
          </div>
        </div>
        <div class="columns" v-if="$parent.mainSection.accordion.respondToReviews.show">
          <div class="column padding-0">
            <div class="columns is-block content">
              <div class="column padding-0 margin-bottom-15">
                Replying to reviews and connecting with customers is fundamental to building a positive online reputation and staying ahead of your competitors. This shows you're a business who cares and gives potential customers a sense of security, which leads to an increase in sales. Always ensure you stay on top of all your replies.
              </div>
              <div class="column padding-0 is-hidden-mobile" v-if="$parent.mainSection.accordion.respondToReviews.showInternalOptions">
                <div class="columns">
                  <div class="column padding-0">
                    <div class="side-accordian-section padding-left-0">
                      <router-link to="/reviews" data-track="Portal Home Review Listing">
                        <div class="columns side-accordian is-mobile">
                          <div class="column is-narrow padding-top-bottom-5 padding-0">
                            <span class="bold-text">{{$parent.business ? $parent.business.review.stats.unrepliedReviews : 0}}</span>
                          </div>
                          <div class="column padding-top-bottom-5">
                            <span>Unreplied Reviews</span>
                          </div>
                          <div class="column is-narrow is-flex padding-0">
                            <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="column padding-0 padding-0">
                    <div class="side-accordian-section padding-left-0">
                      <router-link to="/reviews" data-track="Portal Home Review Listing">
                        <div class="columns side-accordian is-mobile">
                          <div class="column is-narrow padding-top-bottom-5 padding-0">
                            <span class="bold-text">{{$parent.business ? $parent.business.review.stats.unreadReviews : 0}}</span>
                          </div>
                          <div class="column padding-top-bottom-5">
                            <span>Unread Reviews</span>
                          </div>
                          <div class="column is-narrow is-flex padding-0">
                            <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns is-hidden-desktop is-hidden-tablet" v-if="$parent.mainSection.accordion.respondToReviews.showInternalOptions">
              <div class="column">
                <div class="columns">
                  <div class="column padding-0">
                    <div class="side-accordian-section">
                      <router-link to="/reviews" data-track="Portal Home Review Listing">
                        <div class="columns side-accordian is-mobile">
                          <div class="column is-narrow padding-top-bottom-5 padding-0">
                            <span class="bold-text">{{$parent.sideStats.reviewsStats.unrepliedReviews || 0}}</span>
                          </div>
                          <div class="column padding-top-bottom-5">
                            <span>Unreplied Reviews</span>
                          </div>
                          <div class="column is-narrow is-flex padding-0">
                            <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="column padding-0 padding-0">
                    <div class="side-accordian-section">
                      <router-link to="/reviews" data-track="Portal Home Review Listing">
                        <div class="columns side-accordian is-mobile">
                          <div class="column is-narrow padding-top-bottom-5 padding-0">
                            <span class="bold-text">{{$parent.sideStats.reviewsStats.unreadReviews || 0}}</span>
                          </div>
                          <div class="column padding-top-bottom-5">
                            <span>Unread Reviews</span>
                          </div>
                          <div class="column is-narrow is-flex padding-0">
                            <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- Respond to reviews Ends -->
    <div
      class="grey-text increase-conversion-text"
      v-if="accordionType === 'respondToReviews' && $parent.mainSection.accordion.respondToReviews.externalReviews && $parent.mainSection.accordion.respondToReviews.reviews.reviews.length"
    >
      {{$parent.mainSection.accordion.respondToReviews.reviews.reviewsInfo.totalReviews === 1 ? `You have a Review` : `You have 2 new Reviews`}}
    </div>

    <!-- External reviews for respond to reviews Begins -->
    <div
      class="external-reviews"
      v-if="accordionType === 'respondToReviews' && $parent.mainSection.accordion.respondToReviews.externalReviews && $parent.mainSection.accordion.respondToReviews.reviews"
    >
      <ReviewCard
        v-for="(review, index) in $parent.mainSection.accordion.respondToReviews.reviews.reviews"
        :key="index"
        :options="$parent.mainSection.accordion.respondToReviews.reviewsOption"
        :review="review"
        :reviewStats="$parent.mainSection.accordion.respondToReviews.reviews.reviewsInfo"
      />
    </div> <!-- External reviews for respond to reviews Ends -->

    <!-- Collect reviews Begins -->
    <div class="columns accordian-container" v-if="accordionType === 'collectReviews'">
      <div class="column padding-0">
        <div class="columns flex-align-centre is-flex-mobile" data-track="Portal Home Collect Reviews Widget" :class="[{'cursor': !$parent.mainSection.accordion.collectReviews.nextAction || isMobile}]" @click="$parent.handleAccordion('collectReviews')">
          <div class="column is-flex flex-align-centre flex-80">
            <img src="/static/img/home/collect-reviews.svg" alt="icon">&nbsp;&nbsp;
            <span class="blue-text">Collect Reviews</span>
          </div>
          <div class="column has-text-right is-flex flex-justify-end" v-if="!$parent.mainSection.accordion.collectReviews.nextAction || isMobile">
            <img :src="`/static/img/ic-${!$parent.mainSection.accordion.collectReviews.show ? 'right' : 'down'}-arrow.svg`" alt="accordian">
          </div>
        </div>
        <div class="columns" v-if="$parent.mainSection.accordion.collectReviews.show">
          <div class="column padding-0">
            <div class="columns is-block content">
              <div class="column padding-0 margin-bottom-15">
                Digital word-of-mouth has the potential to reach an enormous audience, and collecting reviews ensures you leverage the
                most powerful and trusted form of marketing. Hellopeter automatically sends your reviews to Google and other search
                engines daily which impact search results. These search results contain rich snippet star ratings that improve click-
                through
                rates up to 35%.<br><br>
                Our intelligent review invite technology makes it simple to capture every customer experience by removing all the friction
                and allowing customers to write reviews directly from their email inbox. Use your customers as an army of marketers to
                consistently collect reviews to increase visibility in search engines, grow a trusted online reputation and attract customers
                more easily.
              </div>
              <div class="column padding-0 is-hidden-mobile" v-if="$parent.mainSection.accordion.collectReviews.showInternalOptions">
                <div class="columns is-block">
                  <div class="column padding-0" v-if="$parent.mainSection.accordion.collectReviews.showSetupTemplate">
                    <div class="side-accordian-section padding-left-0">
                      <router-link to="/collect-reviews/review-invites/template" data-track="Portal Home To Setup Review Invite Template">
                        <div class="columns side-accordian is-mobile">
                          <div class="column padding-top-bottom-5 has-text-left">
                            <span>Set-up Email Templates</span>
                          </div>
                          <div class="column is-narrow is-flex padding-0 has-text-right">
                            <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <!-- Internal Send Quick Review Invite Begins -->
                  <div class="column padding-0 send-quick-review-invite" v-if="$parent.mainSection.accordion.collectReviews.showInternalQuickInvite">
                    <div class="side-accordian-section padding-left-0">
                      <div class="columns side-accordian is-mobile is-block">
                        <div class="column is-flex padding-left-0 padding-right-0 has-text-left">
                          <span>Send Quick Review Invite</span>&nbsp;&nbsp;
                          <tooltip-new content-width="445px" :svgInfoIcon="true" class="tooltip-new-content">
                            For highest conversions, we automatically deliver the in-mail template. If you add a mobile number, your customer will receive an SMS invite in addition to the email invite. This doubles your chances of converting the review invite into a review. <b><i>Note - Even though two invites are sent to one customer, only one review invite will be deducted from your review invite quota.</i></b>
                          </tooltip-new>
                        </div>
                        <div class="column padding-top-bottom-5 has-text-left">
                          <div class="columns">
                            <div class="column padding-left-0">
                              <input type="text" class="input" placeholder="First name" v-model="$parent.quickReply.name">
                              <span class="error" v-if="$parent.errors.quickReply.name">*{{$parent.errors.quickReply.name}}</span>
                            </div>
                            <div class="column padding-left-0">
                              <input type="text" class="input" placeholder="Mobile number (optional)" v-model="$parent.quickReply.mobile">
                              <span class="error" v-if="$parent.errors.quickReply.mobile">*{{$parent.errors.quickReply.mobile}}</span>
                            </div>
                            <div class="column padding-left-0 padding-right-0">
                              <input type="text" class="input" placeholder="Email address" v-model="$parent.quickReply.email">
                              <span class="error" v-if="$parent.errors.quickReply.email">*{{$parent.errors.quickReply.email}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="column padding-left-0 padding-right-0 has-text-right">
                          <button
                            data-track="Portal Home Send Quick Review Invite"
                            class="button is-button-dark-blue is-uppercase"
                            :class="[{'is-loading': $parent.isLoading}, {'disabled': $parent.isLoading}]"
                            @click="$parent.handleQuickInvite"
                          >
                            Send Invite
                          </button>
                        </div>
                      </div>
                    </div>
                  </div><!-- Internal Send Quick Review Invite Ends -->
                  <div class="column padding-0">
                    <div class="side-accordian-section padding-left-0">
                      <router-link to="/collect-reviews/review-invites/send" data-track="Portal Home To Send Review Invite Page">
                        <div class="columns side-accordian is-mobile">
                          <div class="column padding-top-bottom-5 has-text-left">
                            <span v-if="$parent.mainSection.accordion.collectReviews.showBulkInvite">Upload A Bulk List Of Customers</span>
                            <span v-else>Invite Customers To Leave A Review</span>
                          </div>
                          <div class="column is-narrow is-flex padding-0 has-text-right">
                            <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="column padding-0">
                    <div class="side-accordian-section padding-left-0">
                      <router-link to="/collect-reviews/review-invites/history" data-track="Portal Home To Review Invite History Page">
                        <div class="columns side-accordian is-mobile">
                          <div class="column padding-top-bottom-5">
                            <span>
                              <b class="bold-text">{{$parent.business ? $parent.business.reviewInvite.stats.notConverted : 0}}</b> Invites Have Not Been Converted&nbsp;&nbsp;
                              <router-link class="internal-link" to="/collect-reviews/review-invites/history">Resend Now</router-link>
                            </span>
                          </div>
                          <div class="column is-narrow is-flex padding-0">
                            <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- Collect reviews Ends -->
    <div class="grey-text increase-conversion-text grey-bottom-border-mobile is-hidden-mobile" v-if="accordionType === 'collectReviews' && $parent.mainSection.accordion.collectReviews.showExternalQuickInvite">{{ $parent.mainSection.accordion.collectReviews.showExternalQuickInviteHeader || 'Increase conversions by resending now'}}</div> <!--Lets get you collecting reviews-->
    <!-- Send quick invite for only collect review in next action begins -->
    <div class="columns is-hidden-mobile accordian-container increase-conversion-section" v-if="accordionType === 'collectReviews' && $parent.mainSection.accordion.collectReviews.showExternalQuickInvite">
      <div class="column">
        <div class="columns is-block">
          <!-- Send Quick Review Invite Begins -->
          <div class="column padding-0 send-quick-review-invite">
            <div class="side-accordian-section padding-left-0">
              <div class="columns side-accordian is-mobile is-block">
                <div class="column is-flex padding-left-0 padding-right-0 has-text-left">
                  <span>Send Quick Review Invite</span>&nbsp;&nbsp;
                  <tooltip-new content-width="445px" :svgInfoIcon="true">
                    For highest conversions, we automatically deliver the in-mail template. If you add a mobile number, your customer will receive an SMS invite in addition to the email invite. This doubles your chances of converting the review invite into a review. <b><i>Note - Even though two invites are sent to one customer, only one review invite will be deducted from your review invite quota.</i></b>
                  </tooltip-new>
                </div>
                <div class="column padding-bottom-0 has-text-left">
                  <div class="columns">
                    <div class="column padding-left-0">
                      <input type="text" class="input" placeholder="First name" v-model="$parent.quickReply.name">
                      <span class="error" v-if="$parent.errors.quickReply.name">*{{$parent.errors.quickReply.name}}</span>
                    </div>
                    <div class="column padding-left-0">
                      <input type="text" class="input" placeholder="Mobile number (optional)" v-model="$parent.quickReply.mobile">
                      <span class="error" v-if="$parent.errors.quickReply.mobile">*{{$parent.errors.quickReply.mobile}}</span>
                    </div>
                    <div class="column padding-left-0 padding-right-0">
                      <input type="text" class="input" placeholder="Email address" v-model="$parent.quickReply.email">
                      <span class="error" v-if="$parent.errors.quickReply.email">*{{$parent.errors.quickReply.email}}</span>
                    </div>
                  </div>
                </div>
                <div class="column padding-top-0 has-text-right">
                  <button
                    data-track="Portal Home Send Quick Review Invite"
                    class="button is-button-dark-blue is-uppercase"
                    :class="[{'is-loading': $parent.isLoading}, {'disabled': $parent.isLoading}]"
                    :disabled="!$parent.quickReply.name || !$parent.quickReply.email"
                    @click="$parent.handleQuickInvite"
                  >
                    Send Invite
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Send Quick Review Invite Ends -->
          <div class="column padding-0">
            <div class="side-accordian-section padding-left-0">
              <router-link to="/collect-reviews/review-invites/send" data-track="Portal Home To Send Review Invite Page">
                <div class="columns side-accordian is-mobile">
                  <div class="column padding-top-bottom-5 has-text-left">
                    <span>Upload A Bulk List Of Customers</span>
                  </div>
                  <div class="column is-narrow is-flex padding-0 has-text-right">
                    <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="column padding-0">
            <div class="side-accordian-section padding-left-0">
              <router-link to="/collect-reviews/review-invites/history" data-track="Portal Home To Review Invite History Page">
                <div class="columns side-accordian is-mobile">
                  <div class="column padding-top-bottom-5">
                    <span>
                      <b class="bold-text">{{$parent.business ? $parent.business.reviewInvite.stats.notConverted : 0}}</b> Invites Have Not Been Converted&nbsp;&nbsp;
                      <router-link
                        to="/collect-reviews/review-invites/history"
                        :class="[{'link': $parent.mainSection.accordion.collectReviews.invitedForReview}, {'internal-link': !$parent.mainSection.accordion.collectReviews.invitedForReview}]"
                      >
                        Resend Now
                      </router-link>
                    </span>
                  </div>
                  <div class="column is-narrow is-flex padding-0">
                    <img src="/static/img/ic-right-arrow.svg" alt="accordian">
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- Send quick invite for only collect review in next action -->
    <!-- Send Quick Review Invite Mobile View For Collect Reviews Begins -->
    <div class="grey-text grey-bottom-border-mobile is-hidden-desktop is-hidden-tablet" v-if="accordionType === 'collectReviews' && $parent.mainSection.accordion.collectReviews.showExternalQuickInvite">Lets get you collecting reviews</div>
    <div class="columns is-hidden-desktop is-hidden-tablet" v-if="accordionType === 'collectReviews' && $parent.mainSection.accordion.collectReviews.showExternalQuickInvite">
      <div class="column padding-0 send-quick-review-invite-mobile">
        <div class="padding-0">
          <div class="columns side-accordian is-mobile is-block">
            <div class="column is-flex padding-0 has-text-left">
              <span>Send Quick Review Invite</span>&nbsp;&nbsp;
              <tooltip-new content-width="445px" :svgInfoIcon="true">
                For highest conversions, we automatically deliver the in-mail template. If you add a mobile number, your customer will receive an SMS invite in addition to the email invite. This doubles your chances of converting the review invite into a review. Note - Even though two invites are sent to one customer, only one review invite will be deducted from your review invite quota.
              </tooltip-new>
            </div>
            <div class="column padding-left-0 padding-right-0">
              <div class="columns">
                <div class="column padding-left-0 padding-right-0">
                  <input type="text" class="input" placeholder="First name" v-model="$parent.quickReply.name">
                  <span class="error" v-if="$parent.errors.quickReply.name">*{{$parent.errors.quickReply.name}}</span>
                </div>
                <div class="column padding-left-0 padding-right-0">
                  <input type="text" class="input" placeholder="Mobile number (optional)" v-model="$parent.quickReply.mobile">
                  <span class="error" v-if="$parent.errors.quickReply.mobile">*{{$parent.errors.quickReply.mobile}}</span>
                </div>
                <div class="column padding-left-0 padding-right-0">
                  <input type="text" class="input" placeholder="Email address" v-model="$parent.quickReply.email">
                  <span class="error" v-if="$parent.errors.quickReply.email">*{{$parent.errors.quickReply.email}}</span>
                </div>
              </div>
            </div>
            <div class="column padding-left-0 padding-right-0">
              <button
                data-track="Portal Home Send Quick Review Invite"
                class="button width-100 is-button-dark-blue is-uppercase"
                :class="[{'is-loading': $parent.isLoading}, {'disabled': $parent.isLoading}]"
                @click="$parent.handleQuickInvite"
              >
                Send Invite
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Send Quick Review Invite Mobile View For Collect Reviews Ends -->

    <!-- Complete business profile Begins -->
    <div class="columns accordian-container" v-if="accordionType === 'businessProfileSetup'">
      <div class="column padding-0">
        <div class="columns flex-align-centre is-flex-mobile" data-track="Portal Home Complete Business Profile Widget" :class="[{'cursor': !$parent.mainSection.accordion.businessProfileSetup.nextAction || isMobile}]" @click="$parent.handleAccordion('businessProfileSetup')">
          <div class="column is-flex flex-align-centre flex-80">
            <img src="/static/img/home/business-profile-setup.svg" alt="icon">&nbsp;&nbsp;
            <span class="blue-text">Business Profile Setup</span>
          </div>
          <div class="column has-text-right is-narrow is-flex flex-justify-end" v-if="!$parent.mainSection.accordion.businessProfileSetup.nextAction || isMobile">
            <img :src="`/static/img/ic-${!$parent.mainSection.accordion.businessProfileSetup.show ? 'right' : 'down'}-arrow.svg`" alt="accordian">
          </div>
        </div>
        <div class="columns" v-if="$parent.mainSection.accordion.businessProfileSetup.show">
          <div class="column padding-0">
            <div class="columns is-block content">
              <div class="column padding-0 margin-bottom-15">
                Customised business profile pages on Hellopeter will help you rank higher in search engines like Google and typically appear as one of the top search results for your brand, often with rich snippet star ratings to help build credibility and stand out from the competition.
                <br><br>
                Completing your business profile on an independent review site makes you stand out as trustworthy in the eyes of your future customers.
                <router-link to="/business/profile" data-track="Portal Home To Complete Business Profile" class="link">Complete profile</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- Complete business profile Ends -->

    <!-- Social Integration Begins -->
    <div class="columns accordian-container" v-if="accordionType === 'socialIntegration'">
      <div class="column padding-0">
        <div class="columns flex-align-centre is-flex-mobile" data-track="Portal Home Social Integration Widget" :class="[{'cursor': !$parent.mainSection.accordion.socialIntegration.nextAction || isMobile}]" @click="$parent.handleAccordion('socialIntegration')">
          <div class="column is-flex flex-align-centre flex-60 flex-40-mobile">
            <img src="/static/img/home/social-integration.svg" alt="icon">&nbsp;&nbsp;
            <span class="blue-text">Social Integration</span>
          </div>
          <div class="column has-text-right">
            <div class="columns is-flex-mobile flex-align-centre">
              <div class="column padding-0 flex-align-centre is-flex" v-if="!$parent.isPaidSubscription">
                <img src="/static/img/free-lock-icon.png" alt="upgrade">&nbsp;&nbsp;
                <router-link data-track="Portal Home To Renew/Upgrade" :to="`/renew-or-upgrade-subscription`"><span class="upgrade">Upgrade</span></router-link>
              </div>
              <div class="column padding-0 is-flex flex-justify-end" v-if="!$parent.mainSection.accordion.socialIntegration.nextAction || isMobile">
                <img :src="`/static/img/ic-${!$parent.mainSection.accordion.socialIntegration.show ? 'right' : 'down'}-arrow.svg`" alt="accordian">
              </div>
            </div>
          </div>
        </div>
        <div class="columns" v-if="$parent.mainSection.accordion.socialIntegration.show">
          <div class="column padding-0">
            <div class="columns is-block content">
              <div class="column padding-0 margin-bottom-15">
                Potential customers are more likely to engage with you if they see other customers are doing it. This is known as social
                proof, and by connecting your Hellopeter account to your social media platforms you get greater visibility for your
                reviews, boost brand visibility and increase traffic from social.
              </div>
              <div class="column padding-0 connect-social-accounts is-hidden-mobile">
                <div class="columns is-block">
                  <div class="column padding-0 social-heading">
                    <b>Connect Social Accounts</b>
                  </div>
                  <div class="column padding-0" :class="[{'disabled': !$parent.isPaidSubscription}]">
                    <div class="columns">
                      <div class="column padding-left-0 padding-bottom-0">
                        <div class="columns">
                          <div class="column is-narrow padding-left-0 padding-top-0"><span class="dot facebook"></span></div>
                          <div class="column is-narrow padding-0 brief-text">Facebook review tab <br>
                            Show off your Hellopeter reviews in a dedicated tab embedded in your Facebook page.
                          </div>
                        </div>
                      </div>
                      <div class="column is-narrow padding-left-0 padding-right-0">
                          <router-link
                            to="/fb-integration"
                            class="button button-orange"
                            data-track="Portal Home Add Facebook Page Tab Button Clicked"
                            :disabled="$parent.user.facebookPageId && !$parent.user.pageAccessToken"
                            v-if="$parent.user.isAddTabButtonVisible"
                          >
                            {{$parent.user.facebookPageId && !$parent.user.pageAccessToken ? 'Added' : 'Add Tab'}}
                          </router-link>
                          <a
                            class="button button-orange"
                            :disabled="true"
                            data-track="Portal Home Remove Facebook Page Tab Button Clicked"
                            v-else
                            @click="$parent.removeFacebookTab"
                          >
                            Remove Tab
                          </a>
                      </div>
                    </div>
                  </div>
                  <div class="column padding-0" :class="[{'disabled': !$parent.isPaidSubscription}]">
                    <div class="columns">
                      <div class="column padding-left-0 padding-top-0">
                        <div class="columns">
                          <div class="column is-narrow padding-left-0 padding-top-0"><span class="dot social-ad"></span></div>
                          <div class="column is-narrow padding-0 brief-text">Social ads <br>
                            Easily turn your reviews into beautiful Social Ads for Instagram, Facebook and Twitter in
                            <br>just a few
                            clicks - no design skills needed.
                          </div>
                        </div>
                      </div>
                      <div class="column is-narrow padding-left-0 padding-right-0">
                        <router-link data-track="Portal Home To Ads Creator Page" class="button button-dark-blue" to="/ads/creator" :disabled="!$parent.isPaidSubscription">
                          Create Ad
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- Social Integration Ends -->

    <!-- Widget Begins -->
    <div class="columns accordian-container" v-if="accordionType === 'widgets'">
      <div class="column padding-0">
        <div class="columns is-flex flex-align-centre is-flex-mobile" data-track="Portal Home Widgets" :class="[{'cursor': !$parent.mainSection.accordion.widgets.nextAction}]" @click="$parent.handleAccordion('widgets')">
          <div class="column is-flex flex-align-centre flex-60 flex-40-mobile">
            <img src="/static/img/home/widgets.svg" alt="icon">&nbsp;&nbsp;
            <span class="blue-text">Widgets</span>
          </div>
          <div class="column has-text-right" v-if="!$parent.mainSection.accordion.widgets.nextAction">
            <div class="columns is-flex-mobile flex-align-centre">
              <div class="column padding-0 flex-align-centre is-flex" v-if="!$parent.isPaidSubscription">
                <img src="/static/img/free-lock-icon.png" alt="upgrade">&nbsp;&nbsp;
                <router-link data-track="Portal Home To Renew/Upgrade Subscription" :to="`/renew-or-upgrade-subscription`"><span class="upgrade">Upgrade</span></router-link>
              </div>
              <div class="column padding-0 is-flex flex-justify-end">
                <img :src="`/static/img/ic-${!$parent.mainSection.accordion.widgets.show ? 'right' : 'down'}-arrow.svg`" alt="accordian">
              </div>
            </div>
          </div>
        </div>
        <div class="columns" v-if="$parent.mainSection.accordion.widgets.show">
          <div class="column padding-0">
            <div class="columns is-block content">
              <div class="column padding-0 margin-bottom-15">
                When customers leave reviews, they create additional content for your website. By installing Hellopeter review widgets on
                your website, you can leverage thousands of additional keywords which help you appear in more search results without
                the help of an SEO agency. And Hellopeter widgets showcase trust which increases conversions as customers are far more
                likely to make a purchase from a website that’s displaying reviews.
              </div>
              <div class="column padding-0 is-hidden-mobile">
                <div class="columns popular-widget-section">
                  <div class="column padding-0 grey-text">Popular Hellopeter widgets</div>
                  <div class="column padding-0 has-text-right"><router-link class="link" to="/onsite-widgets">See all widgets</router-link></div>
                </div>
              </div>
              <div class="column padding-left-0 padding-right-0 is-hidden-mobile" :class="[{'disabled': !$parent.isPaidSubscription}]">
                <div class="columns">
                  <router-link data-track="Portal Home Response To Review Widget" to="/onsite-widgets/details/reviewTab" :class="[{'no-pointer-event': false}]"><img src="/static/img/home/widget-1.jpg" alt="widgets" class="widgets"></router-link>
                  <router-link data-track="Portal Home Response To Review Badge Widget" to="/onsite-widgets/details/reviewBadge" :class="[{'no-pointer-event': false}]"><img src="/static/img/home/widget-2.jpg" alt="widgets" class="widgets"></router-link>
                  <router-link data-track="Portal Home Response To Carousel Widget" to="/onsite-widgets/details/carousel" :class="[{'no-pointer-event': false}]"><img src="/static/img/home/widget-3.jpg" alt="widgets" class="widgets"></router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- Widget Ends -->

    <!-- Google reviews Begins -->
    <div class="columns accordian-container" v-if="accordionType === 'googleReviews' && !$parent.mainSection.accordion.googleReviews.removeWidget">
      <div class="column padding-0">
        <div class="columns flex-align-centre is-flex-mobile" data-track="Portal Home Google Reviews Widget" :class="[{'cursor': !$parent.mainSection.accordion.googleReviews.nextAction}]" @click="$parent.handleAccordion('googleReviews')">
          <div class="column is-flex flex-align-centre flex-60 flex-40-mobile accordion-logo">
            <img src="/static/img/home/google.jpg" alt="icon">&nbsp;&nbsp;
            <span class="blue-text">Google Reviews</span>
          </div>
          <div class="column has-text-right" v-if="!$parent.mainSection.accordion.googleReviews.nextAction">
            <div class="columns is-flex-mobile flex-align-centre">
              <div class="column padding-0 flex-align-centre is-flex" v-if="!$parent.isPaidSubscription">
                <img src="/static/img/free-lock-icon.png" alt="upgrade">&nbsp;&nbsp;
                <router-link data-track="Portal Home To Renew/Upgrade Subscription" :to="`/renew-or-upgrade-subscription`"><span class="upgrade">Upgrade</span></router-link>
              </div>
              <div class="column padding-0 is-flex flex-justify-end">
                <img :src="`/static/img/ic-${!$parent.mainSection.accordion.googleReviews.show ? 'right' : 'down'}-arrow.svg`" alt="accordian">
              </div>
            </div>
          </div>
        </div>
        <div class="columns" v-if="$parent.mainSection.accordion.googleReviews.show">
          <div class="column padding-0">
            <div class="columns is-block content">
              <div class="column padding-left-0 padding-right-0 padding-top-0">
                We make it easy to collect Google reviews, so you can build a consistent online reputation. Harnessing local reviews
                on Google maps will help you rank higher in local search results and give you the power to rise above the competition
                in your area.
              </div>
              <div class="column padding-left-0 padding-right-0 is-hidden-mobile" :class="[{'disabled': !$parent.isPaidSubscription}]">
                <div class="columns">
                  <div class="column google-connect-column">
                    <div class="google-connect-box">
                      <div :class="{'img': true, 'disabled-img-box': !isPaidSubscription}">
                        <div>
                          <img
                            srcset="/static/img/review-invites/Image-403.png,
                            /static/img/review-invites/Image-403@2x.png 2x,
                            /static/img/review-invites/Image-403@3x.png 3x"
                            alt="Google My Business"
                            class="gmb-logo"
                          />
                          <!--<div class="upgrade-popup" @click="$parent.renewOrUpgrade()" v-if="!isPaidSubscription">
                            <img src="/static/img/lock-icon.svg"/>
                            <div class="msg">Upgrade to gain instant access</div>
                          </div>-->
                        </div>
                      </div>
                      <div class="text-row is-block">
                        <strong>Google My Business</strong>
                        <a
                           data-track="Portal Home Google Reviews - Connect Google Account"
                           :class="{'button': true, 'connect-btn': true, 'disabled-connect': !isPaidSubscription}"
                           v-if="!($parent.user.gmbSetupgmbSetup && $parent.user.gmbSetupgmbSetup.data)"
                           @click="$parent.openModal()"
                        >
                          CONNECT
                        </a>
                        <a :disabled="true" class="button connect-btn disabled-connect" v-else>CONNECTED</a>
                      </div>
                    </div>
                  </div>
                  <div class="column padding-left-0 padding-right-0 is-padding-top-0">
                    <div class="location-not-verified columns">
                      <div class="column is-1 left is-hidden-mobile exclamation-sign">!</div>
                      <div class="column is-11 right">
                        To use this feature your Google My Business location needs to be verified.
                        To find out how to verify your location
                        <a
                          class="link"
                          href="https://support.google.com/business/answer/7107242?hl=en"
                          target="_blank"
                          data-track="Portal Home Google Reviews - Setup - Help - how to verify your location"
                        >
                          click here
                        </a>.
                      </div>
                      <GMBModal
                        :show=$parent.toggleModal
                        :page=$parent.page
                        @closeModal="$parent.toggleModal=false"
                        @updateFinished="$emit('updateFinished')"
                      >
                      </GMBModal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- Google reviews Ends -->

    <!-- Review management Begins -->
    <div class="columns accordian-container" v-if="accordionType === 'reviewManagement'">
      <div class="column padding-0">
        <div class="columns flex-align-centre is-flex-mobile" data-track="Portal Home Review Management Widget" :class="[{'cursor': !$parent.mainSection.accordion.reviewManagement.nextAction}]" @click="$parent.handleAccordion('reviewManagement')">
          <div class="column is-flex flex-align-centre flex-60 flex-40-mobile accordion-logo">
            <img src="/static/img/home/fb-google.jpg" alt="icon">&nbsp;&nbsp;
            <span class="blue-text">Review Management</span>
          </div>
          <div class="column has-text-right" v-if="!$parent.mainSection.accordion.reviewManagement.nextAction">
            <div class="columns is-flex-mobile flex-align-centre">
              <div class="column padding-0 flex-align-centre is-flex" v-if="!$parent.isPaidSubscription">
                <img src="/static/img/free-lock-icon.png" alt="upgrade">&nbsp;&nbsp;
                <router-link data-track="Portal Home To Renew/Upgrade Subscription" :to="`/renew-or-upgrade-subscription`"><span class="upgrade">Upgrade</span></router-link>
              </div>
              <div class="column padding-0 is-flex flex-justify-end">
                <img :src="`/static/img/ic-${!$parent.mainSection.accordion.reviewManagement.show ? 'right' : 'down'}-arrow.svg`" alt="accordian">
              </div>
            </div>
          </div>
        </div>
        <div class="columns review-management-section" v-if="$parent.mainSection.accordion.reviewManagement.show">
          <div class="column padding-0">
            <div class="columns is-block content">
              <div class="column padding-0 margin-bottom-15">
                Hellopeter’s one inbox allows you to monitor, manage and track your Google and Facebook reviews from one place.
                Connecting your Google and Facebook accounts gives you complete visibility, and ensures you’re always on top of your
                online reputation.
              </div>
              <div class="column padding-0 is-hidden-mobile">
                <div class="columns is-flex-mobile flex-align-centre">
                  <div class="column padding-0 is-narrow logo">
                    <img src="/static/img/home/hellopeter.svg" alt="hellopeter">
                  </div>
                  <div class="column is-2 padding-0 pad-left-12 app-name">
                    Hellopeter
                  </div>
                  <div class="column connected-text">
                    Connected
                  </div>
                </div>
                <div class="columns is-flex-mobile flex-align-centre" :class="[{'disabled': !$parent.isPaidSubscription}]">
                  <div class="column padding-0 is-narrow logo">
                    <img src="/static/img/home/google-mini.jpg" alt="google">
                  </div>
                  <div class="column is-2 padding-0 pad-left-12 app-name">
                    Google
                  </div>
                  <div
                    class="column link cursor"
                    data-track="Portal Home Google Reviews - Connect Google Account"
                    v-if="!$parent.user.gmbSetupgmbSetup"
                    @click="$parent.openModal()"
                  >
                    Connect your channel
                  </div>
                  <div class="column connected-text" v-else>
                    Connected
                  </div>
                  <GMBModal
                    :show=$parent.toggleModal
                    :page=$parent.page
                    @closeModal="$parent.toggleModal=false"
                    @updateFinished="$emit('updateFinished')"
                  >
                  </GMBModal>
                </div>
                <div class="columns is-flex-mobile flex-align-centre" :class="[{'disabled': !$parent.isPaidSubscription}]">
                  <div class="column padding-0 is-narrow logo">
                    <img src="/static/img/home/facebook.jpg" alt="facebook">
                  </div>
                  <div class="column is-2 padding-0 pad-left-12 app-name">
                    Facebook
                  </div>
                  <div class="column link cursor">
                    Connect your channel
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- Review management Ends -->
  </div>
</template>

<script>
  import {TooltipNew} from '@/widgets'
  import {GMBModal, ReviewCard} from '@/components'

  export default {
    name: 'Accordion',
    components: {
      GMBModal,
      ReviewCard,
      TooltipNew
    },
    props: {
      accordionType: {
        required: true
      }
    },
    computed: {
      /**
       * Check the user type whether it is having Paid plan
       * @return {boolean}
       */
      isPaidSubscription () {
        // If user having Other than Free business
        return this.$parent.userInfo.subscription.name !== 'Free'
      },
      /**
       * Check if app is in mobile view
       * @return {boolean}
       */
      isMobile () {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  $text-color: #58595b;
  $link-color: #30aae1;
  $blue-text-color: #1261a0;

  .accordian-main-section{
    margin-bottom: 15px;
  }
  .side-accordian-section {
    color: $text-color;
    padding: 10px 9px 15px 13px;

    .side-accordian {
      padding: 10px 0px 10px 10px;
      font-size: 12px;
      align-items: center;
      border: solid 1px rgba(88, 89, 91, 0.32);

      .bold-text {
        font-size: 12px;
        font-weight: bold;
      }
      .stats-width {
        width: 13%;
      }
    }
    a {
      color: $text-color;
    }
    .internal-link {
      color: rgba(88, 89, 91, 0.32);
      text-decoration: underline;
    }
  }
  .accordian-container {
    border: solid 1px rgba(88, 89, 91, 0.32);

    &:last-of-type {
      margin-bottom: 5px;
    }
    .columns {
      margin: 0;
    }
    .content {
      color: $text-color;
      padding: 5px 20px 5px 50px;
      font-size: 12px;
    }
    .side-accordian {
      padding: 5px 10px;
    }
    .grey-text {
      color: #707070;
      font-size: 12px;
      opacity: 0.6;
      text-transform: uppercase;
    }
    .popular-widget-section {
      border-bottom: solid 1px rgba(88, 89, 91, 0.32);

      .grey-text {
        margin: 0 0 5px 0;
        margin: auto;
      }
    }
    .widgets {
      /*Mobile view*/
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
    .accordion-logo img {
      width: 30px;
      height: 30px;
      object-fit: contain;
    }
    .google-connect-column {
      width: 38%;
      flex: 0 0 20%;
      padding: 0 12px 0 0;

      .google-connect-box {
        -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px rgba(216, 216, 216, 0.32);
        width: 215px;

        .img {
          padding: 20px 60px;
          background: url('/static/img/review-invites/mask-group-267.png');

          span {
            display: none;
          }
        }

        div {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        strong {
          font-size: 12px;
          line-height: 20px;
          display: block;
          text-align: center;
          margin: 17px 0;
        }

        .text-row {
          text-align: center;
        }

        .connect-btn {
          font-size: 12px;
          color: #fff;
          background: #1261a0;
          width: 130px;
          margin: 0 0 15px;
        }

        .disabled-connect {
          opacity: 0.7;
          background: #cdcbcb;
        }

        .disabled-img-box {
          position: relative;
          text-align: center;
        }

        .lock-wrapper {
          display: none;
        }

        .disabled-img-box {
          span {
            display: block;
            font-size: 14px;
            line-height: 19px;
            color: #fff;
            position: absolute;
            top: 72%;
            left: 0;
            width: 100%;
          }

          .lock-wrapper {
            position: absolute;
            top: 25%;
            display: block;
            width: 100%;
            left: 0;
          }

          .gmb-lock {
            width: 100%;
            max-width: 21px;
            height: auto;
          }
        }

        /*Mobile view*/
        @media screen and (max-width: 767px) {
          width: 100%;
        }
      }

      /*Mobile view*/
      @media screen and (max-width: 767px) {
        width: 100%;
        margin: 0 0 20px 0;
        padding-right: 0;
      }
    }
    .location-not-verified {
      border: 1px solid #E4862C;
      color: #E4862C;
      font-size: 12px;

      .exclamation-sign {
        align-items: center;
        justify-content: center;
        display: flex;
        border-right: 1px solid #E4862C;

      }
    }
    .review-management-section {
      .app-name {
        width: 12%;

        /*Mobile view*/
        @media screen and (max-width: 767px) {
          flex: 0 0 30%;
        }
      }
      .logo {
        width: 4%;

        /*Mobile view*/
        @media screen and (max-width: 767px) {
          flex: 0 0 10%;
        }
      }
      .connected-text {
        color: rgba(88, 89, 91, 0.4);
        text-decoration: none;
        cursor: none;
      }
    }
    .connect-social-accounts {
      font-size: 11px;

      .social-heading {
        font-size: 12px;
      }
    }
    .dot {
      height: 5px;
      width: 5px;
      border-radius: 50%;
      display: inline-flex;

      &.facebook {
        background-color: #f99c50;
      }
      &.social-ad {
        background-color: $blue-text-color;
      }
    }
    &.increase-conversion-section {
      padding: 0 25px 25px 25px;

      .send-quick-review-invite {
        .side-accordian {
          border: solid 1px rgba(88,89,91,0.32);
        }
      }
    }
  }
  .send-quick-review-invite {
    font-size: 12px;

    .input {
      height: 35px;
      color: $text-color;
      font-size: 12px;

      &::placeholder {
        /*opacity: 0.6;*/
      }
      &:focus {
        outline: none;
      }
    }
    .button {
      width: 150px;

      /*Mobile view*/
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
    .side-accordian {
      border: solid 1px $blue-text-color;
    }
    &-mobile {
      font-size: 12px;
      margin: 0 0 30px 0;

      .padding-right-0 {
        padding: 7px 0;
      }
      .input {
        height: 35px;
        color: #707070;
        font-size: 12px;

        &::placeholder {
          opacity: 0.4;
        }
        &:focus {
          outline: none;
        }
      }

      &>>> .tooltip-new {
        .tooltip__content-box {

          /*Mobile view*/
          @media screen and (max-width: 767px) {
            top: 27px;
            left: -110px;
            width: 300px !important;

            &::after {
              top: -9px;
              left: 136px;
              color: #f7f8f8;
              transform: rotate(309deg);
            }
          }
        }

        /*Mobile view*/
        @media screen and (max-width: 767px) {
          left: 2px;
        }
      }
    }
  }
  .tooltip-new-content {
    .tooltip-new {
      &>>> .tooltip__content-box {
        top: -28px;

        /*Mobile view*/
        @media screen and (max-width: 767px) {
          max-width: 165px;
        }
      }
    }
  }
  .tooltip-new-content {
    &>>> .tooltip__content-box {
      .tooltip__content {
        color: $text-color;
      }
    }
  }
  .blue-text {
    color: $blue-text-color;
    font-size: 14px;
    font-weight: bold;
  }
  .link {
    color: $link-color !important;
    text-decoration: underline;
  }
  .cursor {
    cursor: pointer;
  }
  .button {
    width: 130px;
    height: 35px;
    text-transform: uppercase;

    &.button-orange {
      color: #f99c50;
      border: solid 1px #f99c50;
    }
    &.button-dark-blue {
      color: $blue-text-color;
      border: solid 1px $blue-text-color;
    }
  }
  .grey-text {
    color: rgba(88, 89, 91, 0.5);
    opacity: 1;
    margin: 10px 0;
    font-size: 12px;
    text-transform: uppercase;

    &.increase-conversion-text {
      margin: 20px 0 0 0;
    }
  }
  .grey-bottom-border-mobile {
    /*Mobile view*/
    @media screen and (max-width: 767px) {
      color: #58595b;
      opacity: 0.6;
      font-size: 11px;
      border-bottom: 2px solid #dbdbdb;
    }
  }
  .upgrade {
    font-size: 12px;
    color: #30aae1;
    text-decoration: underline;
  }
  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  .error {
    color: red;
  }
  .no-pointer-event {
    pointer-events: none;
  }
  /* Helper css begins */
  .width {
    &-100 {
      width: 100%;
    }
  }
  .margin {
    &-0 {
      margin: 0;
    }
    &-bottom {
      &-0 {
        margin-bottom: 0;
      }
    }
  }
  .padding {
    &-0 {
      padding: 0;
    }
    &-top {
      padding-top: 0;

      &-bottom {
        &-5 {
          padding: 0 5px;
        }
      }
    }
  }
  .flex {
    &-align {
      &-end {
        align-items: end;
      }
    }
    &-40 {
      &-mobile {
        /*Mobile view*/
        @media screen and (max-width: 767px) {
          flex: 40% !important;
        }
      }
    }
    &-60 {
      flex: 60%;
    }
    &-80 {
      flex: 80%;
    }
  }
  /* Helper css ends */
</style>



// WEBPACK FOOTER //
// src/pages/home/Accordion.vue